import React, { useEffect } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";
import digitalMarketing from "../images/digital-marketing.avif";
import { Helmet } from "react-helmet-async";

export default function Digitalmarketingservices() {
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  const primaryColor = "#684df4";

  const digitalMarketingSteps = [
    { icon: "fa-search", title: "In-depth Market & Audience Analysis", desc: "We research your industry, competitors, target demographics, and buyer behavior to uncover high-value opportunities and pain points." },
    { icon: "fa-lightbulb", title: "Custom Strategy & Planning", desc: "Tailored multi-channel digital marketing plans aligned with your business goals — from awareness to conversion and retention." },
    { icon: "fa-users", title: "Precise Audience Segmentation", desc: "We segment audiences by behavior, interests, location, and intent — delivering hyper-personalized messages that resonate and convert." },
    { icon: "fa-pen-nib", title: "High-Impact Content Creation", desc: "Compelling copy, visuals, videos, and graphics crafted to engage, educate, and inspire action across all channels." },
    { icon: "fa-chart-line", title: "SEO & Organic Growth", desc: "On-page, off-page, and technical SEO to boost organic visibility, rankings, and sustainable long-term traffic." },
    { icon: "fa-bullhorn", title: "Paid Ads & PPC Campaigns", desc: "High-ROI Google Ads, Facebook/Instagram, LinkedIn, and YouTube campaigns — optimized daily for maximum reach and conversions." },
    { icon: "fa-share-alt", title: "Social Media Management & Growth", desc: "Strategic posting, community engagement, influencer collaborations, and content calendars that build brand loyalty and virality." },
    { icon: "fa-chart-pie", title: "Performance Tracking & Optimization", desc: "Real-time analytics, A/B testing, attribution modeling, and monthly reporting — continuously refining for better ROI." },
  ];

  return (
    <div>
      <Helmet>
        <title>Full-Service Digital Marketing Agency - Technic Mentors</title>
        <link rel="canonical" href="https://technicmentors.com/digital-marketing-services/" />
      </Helmet>

      {/* Hero Header */}
      <div className="allHeaderBg">
        <div className="allHeader-overlay d-flex align-items-center justify-content-center">
          <div>
            <h1 className="head text-center text-white animate__animated animate__zoomIn allHeaderP">
              Digital Marketing Services
            </h1>
          </div>
        </div>
      </div>

      {/* Introduction */}
      <div className="container mt-5" data-aos="fade-up" data-aos-duration="1000">
        <div className="row align-items-center g-5">
          <div className="col-lg-6" data-aos="fade-right" data-aos-duration="1200">
            <div className="section-title text-start mb-4">
              <h2>Think Big, Go Big</h2>
              <h3 style={{ fontSize: "2.4rem", fontWeight: 700 }}>
                Dominate Digital with Our <span>Proven Marketing Strategies</span>
              </h3>
            </div>
            <p style={{ textAlign: "justify", lineHeight: 1.8, fontSize: "1.05rem" }}>
              In 2025+, customers discover, research, and buy through digital channels first. We help businesses in Pakistan and globally build powerful online presence, generate qualified leads, increase conversions, and create loyal brand advocates through integrated, data-driven digital marketing.
            </p>
            <p style={{ textAlign: "justify", lineHeight: 1.8 }}>
              From strategy to execution — SEO, paid ads, social media, content, email, analytics — we deliver measurable growth across the full customer journey.
            </p>
          </div>

          <div className="col-lg-6" data-aos="fade-left" data-aos-duration="1200">
            <img
              src={digitalMarketing}
              alt="Digital Marketing Services"
              className="img-fluid "
              style={{ borderRadius: "16px" }}
            />
          </div>
        </div>
      </div>

      {/* How We Do It - Cards */}
      <div className="container my-2 py-2" data-aos="fade-up" data-aos-duration="1000">
        <div className="section-title text-center mb-2">
          <h3>Our End-to-End Digital Marketing Process</h3>
        </div>
        <div className="row g-4">
          {digitalMarketingSteps.map((item, i) => (
            <div className="col-lg-3 col-md-6" key={i}>
              <div
                className="card shadow-sm h-100 text-center p-4"
                style={{
                  transition: 'all 0.28s ease',
                  borderRadius: '16px',
                  border: '1px solid #e0e0e0',
                  backgroundColor: '#ffffff',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = primaryColor;
                  e.currentTarget.style.color = '#ffffff';
                  e.currentTarget.style.transform = 'translateY(-12px) scale(1.04)';
                  e.currentTarget.style.boxShadow = '0 25px 60px rgba(0,0,0,0.18)';
                  e.currentTarget.style.borderColor = primaryColor;
                  const icon = e.currentTarget.querySelector('i');
                  if (icon) icon.style.color = '#ffffff';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'white';
                  e.currentTarget.style.color = 'inherit';
                  e.currentTarget.style.transform = 'translateY(0) scale(1)';
                  e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.08)';
                  e.currentTarget.style.borderColor = '#e0e0e0';
                  const icon = e.currentTarget.querySelector('i');
                  if (icon) icon.style.color = primaryColor;
                }}
              >
                <i
                  className={`fa-solid ${item.icon} fa-4x mb-4`}
                  style={{ color: primaryColor, transition: 'color 0.28s ease' }}
                ></i>
                <h5 className="mb-3 fw-bold">{item.title}</h5>
                <p className="mb-0 small" style={{ lineHeight: 1.6 }}>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Impact / Closing Section */}
      <div
        className="container-fluid py-2"
        style={{
          background: `linear-gradient(135deg, ${primaryColor}08 0%, #f8f9fa 100%)`,
        }}
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center">
              <h3 className="mb-4" style={{ fontWeight: 700 }}>
                Why Digital Marketing Transforms Businesses Today
              </h3>
              <p className="lead mb-4" style={{ lineHeight: 1.8 }}>
                Digital channels give you precise targeting, real-time measurement, unmatched scalability, and the ability to build lasting relationships at a fraction of traditional advertising costs. We help brands in Gujranwala, across Pakistan, and internationally increase visibility, generate high-quality leads, improve conversion rates, and maximize ROI.
              </p>
              <p style={{ fontSize: "1.1rem", maxWidth: "900px", margin: "0 auto 2rem" }}>
                With constant algorithm updates, emerging platforms, and shifting user behavior — we stay ahead, adapting strategies fast while keeping your brand authentic and results-focused.
              </p>

           <a
  href="/contact"
  className="primaryBtn px-4 py-2 mb-3"
  style={{ display: "inline-block" }}
>
  Get Free Consultation &rarr;
</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}